import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Users from '@/components/Users'
import User from '@/components/User'
import Tickets from '@/components/Tickets'
import Companies from '@/components/Companies'
import Company from '@/components/Company'
import Device from '@/components/Device'
import Summary from '@/components/Summary'

Vue.use(Router);

const router = new Router({
  routes: [{
    path: '/',
    name: 'HomeLogin',
    component: Login
  }, {
    path: '/login',
    name: 'Login',
    component: Login
  }, {
    path: '/summary',
    name: 'Summary',
    component: Summary,
    meta: { requiresAuth: true }
  }, {
    path: '/users',
    component: Users,
    name: 'Users',
    meta: { requiresAuth: true }
  }, {
    path: '/users/:id',
    props: true,
    component: User,
    name: 'User',
    meta: { requiresAuth: true }
  }, {
    path: '/tickets',
    props: true,
    component: Tickets,
    name: 'Tickets',
    meta: { requiresAuth: true }
  }, {
    path: '/tickets',
    props: true,
    component: Tickets,
    name: 'Home',
    meta: { requiresAuth: true }
  }, {
    path: '/devices/:id',
    props: true,
    component: Device,
    name: 'Device',
    meta: { requiresAuth: true }
  }, {
    path: '/companies',
    component: Companies,
    name: 'Companies',
    meta: { requiresAuth: true }
  }, {
    path: '/companies/:id',
    component: Company,
    props: true,
    name: 'Company',
    meta: { requiresAuth: true }
  }]
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    let token = window.sessionStorage.getItem('token') != null;
    let hasrole = to.meta.role == null || to.meta.role.split('|').indexOf(window.sessionStorage.getItem('role')) != -1;
    if (!token || !hasrole) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      })
    } else {
      next()
    }
  } else {
    next()
  }
});

export default router
